const Blogs = () => {
  return (
    <div className="min-h-screen bg-canvas pb-20 text-ink">
      <section className="relative overflow-hidden border-b border-primary/10 bg-white">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-white to-white" />
        <div className="relative mx-auto flex max-w-5xl flex-col items-center gap-4 px-4 py-12 text-center lg:px-6">
          <h1 className="text-3xl font-semibold sm:text-4xl">Blogs</h1>
          <p className="max-w-3xl text-sm leading-relaxed text-ink-muted sm:text-base">
            Fresh perspectives on language learning, cultural intelligence, productivity, and success
            stories from The Lingua Alliance community.
          </p>
        </div>
      </section>

      <section className="mx-auto mt-16 w-full max-w-5xl px-4 lg:px-6">
        <h2 className="text-2xl font-semibold sm:text-3xl">Latest Articles</h2>
        <div className="mt-8 space-y-6">
          {[1, 2, 3].map((item) => (
            <article
              key={item}
              className="rounded-2xl border border-primary/10 bg-white p-6 shadow-elevated transition hover:-translate-y-1 hover:shadow-float"
            >
              <span className="inline-flex rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-primary">
                Insights
              </span>
              <h3 className="mt-3 text-lg font-semibold text-ink">
                Lorem ipsum dolor sit amet consectetur adipiscing elit
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-muted">
                Tempor commodo ullamcorper a lacus vestibulum sed arcu non odio. Tristique senectus et
                netus et malesuada fames. Ultrices neque ornare aenean euismod elementum nisi quis.
              </p>
              <a
                href="/blogs"
                className="mt-4 inline-flex items-center text-sm font-semibold text-primary transition hover:text-primary/80"
              >
                Read More →
              </a>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Blogs;

